import { useState } from "react";
import { Grid, RenderEnderecoPrint } from "../../../../components";
import { value } from "../../../../helpers";
import {
  formatPrice,
  formatCpf,
  formatCnpj,
  formatTelefone,
  formatCelular,
} from "../../../../utils";
import { format } from "date-fns";
import "../../../orcamentos/addOrcamento/components/mainPrintLayout.style.css";

const MainPrint = ({ data }) => {
  const [aspectRatio, setAspectRatio] = useState(0);
  const aspectLogo = (event) => {
    setAspectRatio(event.target.naturalWidth / event.target.naturalHeight);
  };

  if (!data?.empresa) {
    return null;
  }

  return (
    <div>
      <Grid
        item
        md={12}
        xs={12}
        className="d-flex justify-content-between align-items-center"
      >
        <div className="d-flex justify-content-between align-items-center">
          {data?.empresa?.imagemLogo ? (
            <img
              className="me-3"
              src={data.empresa.imagemLogo}
              alt="logo da empresa"
              onLoad={aspectLogo}
              width={100}
              height={aspectRatio <= 1.5 ? 100 : 20}
            />
          ) : null}
          <div>
            <b>{data.empresa.fantasia}</b>
            <br />
            CNPJ - {formatCnpj(data.empresa.cnpjCpf)}
            <br />
            {`${data.empresa.enderecoLogradouro} - ${data.empresa.enderecoLogradouroNumero} - ${data.empresa.enderecoBairro} - ${data.empresa.enderecoCidade}-${data.empresa.enderecoUF}`}
          </div>
        </div>
        <div className="me-5">
          {data.empresa.telefone.length === 10
            ? formatTelefone(data.empresa.telefone)
            : formatCelular(data.empresa.celular)}
          <br />
          {data.empresa.email}
          <br />
          {data?.vendedor?.nomeRazaoSocial ? (
            <b>Vendedor - {data.vendedor.nomeRazaoSocial}</b>
          ) : (
            ""
          )}
        </div>
      </Grid>
      <Grid item md={12} xs={12} className="mt-4">
        <table className="table">
          <thead style={{ background: "#E7E5E6" }}>
            <tr style={{ background: "#E7E5E6" }}>
              <th className="d-flex justify-content-between align-items-center">
                <span className="fs-5 fw-bold">
                  {`NF DE SAÍDA - ${data.serieDocumento} | ${data.numeroDocumento}`}
                </span>
                <b className="fw-bold">
                  {format(
                    new Date(Date.parse(data.dataEmissao)),
                    "dd/MM/yyyy HH:MM",
                  )}
                </b>
              </th>
            </tr>
          </thead>
        </table>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className="d-flex justify-content-between align-items-center mt-2"
      ></Grid>
      <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
        <table className="table">
          <thead style={{ background: "#E7E5E6" }}>
            <tr>
              <th className="p-0">DADOS DO CLIENTE</th>
            </tr>
          </thead>
        </table>
      </Grid>
      <div className="flex-print-container orcamento-print-fs-07">
        <div className="container-item-50">
          <div>
            <div>
              <b className="me-2 fs-7">Cliente:</b>
              <span className="fs-7 fw-normal">
                {data.cliente?.nomeRazaoSocial}
              </span>
            </div>
            <div>
              <b className="me-2 fs-7">Endereço:</b>
              <span className="fs-7 fw-normal">
                <RenderEnderecoPrint enderecoCliente={data?.enderecoCliente} />
              </span>
            </div>
            <div>
              <b className="me-2 fs-7">Telefone:</b>
              <span className="fs-7 fw-normal">
                {`${formatTelefone(data.cliente?.telefone) ?? ""} ${
                  data.cliente?.celular
                    ? " | " + formatCelular(data.cliente?.celular)
                    : ""
                }`}
              </span>
            </div>
          </div>
        </div>
        <div className="container-item-40">
          <div>
            <div>
              <b className="me-2 fs-7">CNPJ/CPF:</b>
              <span className="fs-7 fw-normal">
                {data.cliente?.naturezaSocial === "fisica"
                  ? formatCpf(data.cliente?.cnpjCpf)
                  : formatCnpj(data.cliente?.cnpjCpf)}
              </span>
            </div>
            <div>
              <b className="me-2 fs-7">Estado:</b>
              <span className="fs-7 fw-normal">{data.estadoCliente ?? ""}</span>
            </div>
            <div>
              <b className="me-2 fs-7">E-mail:</b>
              <span className="fs-7 fw-normal">{data.cliente?.email}</span>
            </div>
          </div>
        </div>
      </div>
      <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
        <table className="table">
          <thead style={{ background: "#E7E5E6" }}>
            <tr>
              <th className="p-0">PRODUTOS</th>
            </tr>
          </thead>
        </table>
      </Grid>
      <Grid item md={12} xs={12}>
        <table className="table table-striped">
          <thead>
            <tr className="orcamento-print-fs-07">
              <th>ITEM</th>
              <th style={{ width: "40%" }}>DESCRIÇÃO</th>
              <th className="text-center">UND.</th>
              <th className="text-center">QTD.</th>
              <th style={{ width: "12%" }} className="text-end">
                VR. UNIT.
              </th>
              <th className="text-end">SUBTOTAL</th>
            </tr>
          </thead>
          <tbody>
            {data?.nfSaidaItens?.length &&
              data.nfSaidaItens.map((item) => (
                <tr key={item.id} className="orcamento-print-fs-07">
                  <td>{item.codigo}</td>
                  <td>{item?.produto || item?.descricao}</td>
                  <td className="text-center">{item.unidade}</td>
                  <td className="text-center">{item.quantidade}</td>
                  <td className="text-end">
                    {item.valor ? parseFloat(item.valor).toFixed(2) : "0"}
                  </td>
                  <td className="text-end">
                    {item.subtotal ? parseFloat(item.subtotal).toFixed(2) : "0"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Grid>

      <div className="totals-container">
        <div className="total-row">
          <strong>VALOR TOTAL DOS PRODUTOS:</strong>
          <span>{formatPrice(data?.totalMercadoria || 0, false)}</span>
        </div>
        <div className="total-row">
          <strong>DESCONTO:</strong>
          <span>{formatPrice(data?.desconto || 0, false)}</span>
        </div>
        <div className="total-row">
          <strong>ACRÉSCIMO:</strong>
          <span>{formatPrice(data?.acrescimo || 0, false)}</span>
        </div>
        <div className="total-row">
          <strong>DESPESAS:</strong>
          <span>{formatPrice(data?.despesas || 0, false)}</span>
        </div>
        <div className="total-row grand-total">
          <strong>TOTAL DA NOTA:</strong>
          <span>{formatPrice(data?.totalVenda || 0, false)}</span>
        </div>
      </div>

      <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
        <table className="table">
          <thead style={{ background: "#E7E5E6" }}>
            <tr>
              <th className="p-0">DADOS DE PAGAMENTO</th>
            </tr>
          </thead>
        </table>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className="mt-2 d-flex justify-content-between orcamento-print-fs-07"
      >
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">Nº TÍTULO</th>
              <th scope="col">VENCIMENTO</th>
              <th scope="col">VALOR</th>
              <th scope="col">MEIO DE PAGAMENTO</th>
            </tr>
          </thead>
          <tbody>
            {data?.pagamentos?.length &&
              data.pagamentos.map((parcela) => (
                <tr key={parcela.id}>
                  <td className="text-center">
                    {`NF ${data.serieDocumento ?? 0}/${data.numeroDocumento}-${
                      parcela.numeroTitulo
                    }`}
                  </td>
                  <td className="text-center">
                    {new Date(
                      Date.parse(parcela.dataVencimento),
                    ).toLocaleDateString("pt-BR")}
                  </td>
                  <td className="text-center">
                    {formatPrice(parcela?.valorTitulo || 0, false)}
                  </td>
                  <td className="text-center">
                    {
                      value.autoComplete(
                        data.meioPagamentoList,
                        parcela.meioPagamentoId,
                      )?.descricao
                    }
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Grid>
      <Grid item md={12} xs={12} className="mt-4 orcamento-print-fs-07">
        <table className="table">
          <thead style={{ background: "#E7E5E6" }}>
            <tr>
              <th className="p-0">OBSERVAÇÕES</th>
            </tr>
          </thead>
        </table>
      </Grid>
      <div style={{ width: "100%" }}>
        <span className="fs-6 fw-normal">{data.informacoesAdicionais}</span>
      </div>
      <div
        style={{
          marginTop: "5rem",
          width: "100%",
          textAlign: "center",
          padding: "3rem",
        }}
      >
        <div style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
          <hr
            style={{ borderTop: "1px solid #666", width: "100%", margin: 0 }}
          />
          <span className="orcamento-print-fs-07 fw-normal text-center">
            Assinatura do Cliente
          </span>
          <div className="mt-5 d-flex justify-content-end">
            <span className="orcamento-print-fs-07 fw-light">
              Documento de saída emitido no Siaf Evolution –
              www.siafevolution.com.br
            </span>
          </div>
        </div>
      </div>
      {data?.status === "CANCELADA" && (
        <span className="danfe_cancelada">CANCELADA</span>
      )}
    </div>
  );
};

export default MainPrint;
